<template>
  <div class="dashboard">
    <div class="dashboard__container">
      <div class="dashboard__container--header mb-2">
        <h1>Orders</h1>
        <span>
          
          <button class="btn btn__small ml-3" v-bind:class="{ 'btn__dark': showOpen, 'btn__outlined btn__small': !showOpen }" @click="showOpenOrders()">Open Orders</button>

          <button class="btn btn__small ml-3" v-bind:class="{ 'btn__dark': !showHeld, 'btn__outlined btn__small': !showHeld }" @click="showHeldOrders()">Held Orders</button>

          <button class="btn btn__small ml-3" v-bind:class="{ 'btn__dark': showClosed, 'btn__outlined btn__small': !showClosed }" @click="showClosedOrders()">Closed Orders</button>

          <router-link :to="{name: 'addevent'}" class="color--text">
            <button class="btn btn__small btn__outlined ml-3">New Order</button>
          </router-link>
        </span>
        
      </div>
      <div class="dashboard__container--body">
          <Loader v-if="!events || events.length == 0" />
          <vue-good-table
            v-if="showOpen"
              :columns="columns"
              :rows="openEvents"
               styleClass="vgt-table condensed"
              :search-options="{
                enabled: true,
                placeholder: 'Search this table',
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 50,
              }"
            >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'created'">
                <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
              </span>
              <span v-else-if="props.column.field == 'visible'">
                <i class="fa-solid fa-check" v-if="props.row.visible" style="color:green;"></i>
              </span>
              <span v-else-if="props.column.field == 'title'">
                <router-link :to="`/orders/` + props.row.id">
                  {{props.row.title}}
                </router-link>
              </span>
              <span v-else-if="props.column.field == 'client'">
               <!--  <span v-if="props.row.venue.client && props.row.venue.client[0]">
                  {{props.row.venue.client[0].title}}
                </span> -->
                <span v-if="props.row.client && props.row.client[0]">
                  {{props.row.client[0].title}}
                </span>
              </span>
              <span v-else-if="props.column.field == 'watchlist'">
                <button v-if="!isWatchList(props.row)" class="btn btn__icon" @click="addWatch(props.row)"><i class="fa-regular fa-star"></i></button>
                 <button v-if="isWatchList(props.row)" class="btn btn__icon" @click="removeWatch(props.row)"><i class="fa-solid fa-star warning"></i></button>
              </span>
              <span v-else-if="props.column.field == 'groups'">
                <span v-if="!props.row.groups || props.row.groups.length == 0">
                  <i class="fa-solid fa-user-group ml-2 mr-2" style="opacity:50%;"></i>
                </span>
                <span v-if="props.row.groups && props.row.groups.length > 0">
                  <v-popover>
                    <i class="fa-solid fa-user-group ml-2 mr-2 blueHue"></i>
                    <template slot="popover">
                      <span v-for="z in props.row.groups">{{z}} / </span>
                    </template>
                  </v-popover>
                </span>
                <!-- <span v-if="props.row.groups && props.row.groups.length >= 1">
                  <button class="chipDark mb-1" v-for="(item, index) in props.row.groups" :key="index">{{item.title}}</button>
                </span> -->
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
          <vue-good-table
            v-if="showHeld"
              :columns="columns"
              :rows="heldEvents"
               styleClass="vgt-table condensed"
              :search-options="{
                enabled: true,
                placeholder: 'Search this table',
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 50,
              }"
            >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'created'">
                <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
              </span>
              <span v-else-if="props.column.field == 'title'">
                <router-link :to="`/orders/` + props.row.id">
                  {{props.row.title}}
                </router-link>
              </span>
              <span v-else-if="props.column.field == 'visible'">
                <i class="fa-solid fa-check" v-if="props.row.visible" style="color:green;"></i>
              </span>
              <span v-else-if="props.column.field == 'client'">
                <span v-if="props.row.venue.client && props.row.venue.client[0]">
                  {{props.row.venue.client[0].title}}
                </span>
                <span v-if="props.row.client && props.row.client[0]">
                  {{props.row.client[0].title}}
                </span>
              </span>
              <span v-else-if="props.column.field == 'watchlist'">
                <button v-if="!isWatchList(props.row)" class="btn btn__icon" @click="addWatch(props.row)"><i class="fa-regular fa-star"></i></button>
                 <button v-if="isWatchList(props.row)" class="btn btn__icon" @click="removeWatch(props.row)"><i class="fa-solid fa-star warning"></i></button>
              </span>
              <span v-else-if="props.column.field == 'groups'">
                <span v-if="!props.row.groups || props.row.groups.length == 0">
                  <i class="fa-solid fa-user-group ml-2 mr-2" style="opacity:50%;"></i>
                </span>
                <span v-if="props.row.groups && props.row.groups.length > 0">
                  <v-popover>
                    <i class="fa-solid fa-user-group ml-2 mr-2 blueHue"></i>
                    <template slot="popover">
                      <span v-for="z in props.row.groups">{{z}} / </span>
                    </template>
                  </v-popover>
                </span>

                <!-- <span v-if="props.row.groups && props.row.groups.length >= 1">
                  <button class="chipDark mb-1" v-for="(item, index) in props.row.groups" :key="index">{{item.title}}</button>
                </span> -->
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
          <vue-good-table
            v-if="showClosed"
              :columns="columns"
              :rows="closedEvents"
               styleClass="vgt-table condensed"
              :search-options="{
                enabled: true,
                placeholder: 'Search this table',
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 50,
              }"
            >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'created'">
                <span v-if="props.row.created">{{formatDate(props.row.created)}}</span>
              </span>
              <span v-else-if="props.column.field == 'title'">
                <router-link :to="`/orders/` + props.row.id">
                  {{props.row.title}}
                </router-link>
              </span>
              <span v-else-if="props.column.field == 'visible'">
                <i class="fa-solid fa-check" v-if="props.row.visible" style="color:green;"></i>
              </span>
              <span v-else-if="props.column.field == 'watchlist'">
                <button v-if="!isWatchList(props.row)" class="btn btn__icon" @click="addWatch(props.row)"><i class="fa-regular fa-star"></i></button>
                 <button v-if="isWatchList(props.row)" class="btn btn__icon" @click="removeWatch(props.row)"><i class="fa-solid fa-star warning"></i></button>
              </span>
              <span v-else-if="props.column.field == 'groups'">
                <span v-if="!props.row.groups || props.row.groups.length == 0">
                  <i class="fa-solid fa-user-group ml-2 mr-2" style="opacity:50%;"></i>
                </span>
                <span v-if="props.row.groups && props.row.groups.length > 0">
                  <v-popover>
                    <i class="fa-solid fa-user-group ml-2 mr-2 blueHue"></i>
                    <template slot="popover">
                      <span v-for="z in props.row.groups">{{z}} / </span>
                    </template>
                  </v-popover>
                </span>
                <!-- <span v-if="props.row.groups && props.row.groups.length >= 1">
                  <button class="chipDark mb-1" v-for="(item, index) in props.row.groups" :key="index">{{item.title}}</button>
                </span> -->
              </span>
              <span v-else-if="props.column.field == 'client'">
                <span v-if="props.row.client && props.row.client[0]">
                  {{props.row.client[0].title}}
                </span>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        
      </div>
    </div>
  </div>
</template>


<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import router from '@/router'
const fb = require('../../firebaseConfig.js')

export default {
  name: 'events',
  data: () => ({
    showOpen: true,
    showHeld: false,
    showClosed: false,
    showAllGroups: true,
    showMyGroups: false,
    columns: [
      {
        label: 'Start Date',
        field: 'startDate',
      },
      {
        label: 'Watchlist',
        field: 'watchlist',
        tdClass: 'text-center-all',
        width: '80px'
      },
      {
        label: 'Title',
        field: 'title',
      },
      {
        label: 'Order #',
        field: 'jobNum',
        width: '100px'
      },
      {
        label: 'PO/Ref',
        field: 'refNum',
        width: '100px'
      },
      {
        label: 'Client',
        field: 'client',
      },
      {
        label: 'City',
        field: 'event_city',
      },
      {
        label: 'State',
        field: 'event_state',
      },
      {
        label: 'Venue',
        field: 'venue_title',
      },
      {
        label: 'Groups',
        field: 'groups',
      },
      {
        label: 'Published',
        field: 'visible',
      },
    ],
    // columns2: [
    //   {
    //     label: 'Name',
    //     field: 'title',
    //   },
    //   {
    //     label: 'Followers',
    //     field: 'followers',
    //   },
    //   {
    //     label: 'City',
    //     field: 'address.city',
    //     thClass: 'hidden-small',
    //     tdClass: 'hidden-small',
    //   },
    //   {
    //     label: 'State',
    //     field: 'address.state',
    //   },
    // ]
  }),
  created () {
    if (!this.events || this.events.length < 1) {
      this.$store.dispatch("getEvents")
    }
  },
  computed: {
    ...mapState(['currentUser', 'events', 'eventsTotal', 'eventsTotalNext', 'userProfile']),
    
    openEvents() {
      if (this.showOpen) {
        return this.events.filter(event => {
          return (!event.status || event.status == 'Open')
        })
      }
    },
    closedEvents() {
      if (this.showClosed) {
        return this.events.filter(event => {
          return (event.status == 'Closed')
        })
      }
    },
    heldEvents() {
      if (this.showHeld) {
        return this.events.filter(event => {
          return (event.status == 'On-Hold')
        })
      }
    }
  },
  components: {
    Loader,
  },
  methods: {
    isWatchList(row) {
      if (this.userProfile && this.userProfile.orderWatchList && this.userProfile.orderWatchList.includes(row.id)) {
        return true
      } else {
        return false
      }
    },
    showOpenOrders() {
      this.showOpen = true
      this.showClosed = false
      this.showHeld = false
    },
    showClosedOrders() {
      this.showOpen = false
      this.showClosed = true
      this.showHeld = false
    },
    showHeldOrders() {
      this.showOpen = false
      this.showClosed = false
      this.showHeld = true
    },
    // onRowClick(params) {
    //   let url = `/orders/` + params.row.id
    //   console.log(url)
    //   router.push(url)
    // },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY, hh:mm a')
      } else {
        return null
      }
    },
    async addWatch(row) {
      await this.$store.dispatch('watchOrder', row.id)
    },
    async removeWatch(row) {
      await this.$store.dispatch('unWatchOrder', row.id)
    },
  },
  beforeDestroy () {
    this.columns = null
    delete this.columns
    this.showOpen = null
    delete this.showOpen
    this.showHeld = null
    delete this.showHeld
    this.showClosed = null
    delete this.showClosed
    this.showAllGroups = null
    delete this.showAllGroups
    this.showMyGroups = null
    delete this.showMyGroups
    delete this.formatDate
    delete this.onRowClick
    delete this.showHeldOrders
    delete this.showClosedOrders
    delete this.showOpenOrders
    delete this.openEvents
    delete this.closedEvents
    delete this.heldEvents
    this.$store.dispatch("clearEvents")
    console.log(this)
  }
}
</script>